/**
 * Shared constants used by both mobile and web apps.
 */

/** Maximum number of expenses per group for free users */
export const FREE_GROUP_EXPENSE_LIMIT = 50;

export const DEFAULT_CURRENCY = 'CZK';

export const GROUP_COLORS = [
  '#6366F1', // Indigo
  '#8B5CF6', // Purple
  '#EC4899', // Pink
  '#EF4444', // Red
  '#F97316', // Orange
  '#EAB308', // Yellow
  '#22C55E', // Green
  '#14B8A6', // Teal
  '#06B6D4', // Cyan
  '#3B82F6', // Blue
] as const;

/**
 * Premium features that propagate to all group members when ANY member has premium.
 * Note: advanced_statistics and custom_categories are free for all users.
 */
export const GROUP_PROPAGATING_FEATURES: readonly string[] = [
  'unlimited_expenses',
  'receipt_ocr',
  'recurring_expenses',
  'csv_export',
  'group_budgets',
];

export const SPLIT_TYPE_LABELS: Record<string, string> = {
  equal: 'Equal',
  exact: 'Exact amounts',
  percentage: 'By percentage',
  shares: 'By shares',
};
